import { azureTables, STRINGS_EN, tableActions } from "../../constant";
import CenteredWrapper from "../../components/CenteredWrapper";
import { useUserContext } from "../../context/userGetContext";
import withLoading from "./components/Loader";
import UserEnvironmentProvider from "./components/UserEnvironmentProvider";
import useQuery from "../../hooks/useQuery";
import AddAccount from "./components/AddAccount";
import HandleDsso from "./components/HandleDsso";
import CloseWindow from "./components/CloseWindow";
import { keys } from "../../constant/keyConfig";
import useTableOperations from "../../hooks/useTableOperations";
import { getLoader } from "../../utils/common";

function TeamsContextProvider() {
  const teamsContext = useUserContext();
  const query = useQuery();
  const addAccountQuery = query.get(keys.ADD_ACCOUNT);
  const dssoUrl = query.get(keys.URL);
  const authenticationId = query.get(keys.AUTHENTICATION_ID);
  const env = query.get(keys.ENV);
  const v1V2Flag = teamsContext?.v1V2Flag;
  const notificationEndpoint = process.env.REACT_APP_REACTAPPNOTIFICATIONURL;


  if (
    teamsContext?.fromTeams &&
    // data?.status !== STRINGS_EN.STATUS_CODE_500 
    v1V2Flag !== null
    &&
    (!v1V2Flag ||
      v1V2Flag.toString() !== STRINGS_EN.MST_MA_VERSION_2)
  ) {
    window.location.assign(notificationEndpoint);
    return null;
  }

  if (dssoUrl) {
    return (
      <CenteredWrapper>
        <HandleDsso authenticationId={authenticationId} dssoUrl={dssoUrl} />
      </CenteredWrapper>
    );
  }

  if (env) {
    return (
      <CenteredWrapper>
        <CloseWindow env={env} />
      </CenteredWrapper>
    );
  }

  if (addAccountQuery) {
    return (
      <CenteredWrapper>
        <AddAccount />
      </CenteredWrapper>
    );
  }

  const LoadingComponent = withLoading(UserEnvironmentProvider);

  return (
    <CenteredWrapper>
      <LoadingComponent
        message={STRINGS_EN.CONTEXT}
        loading={teamsContext?.fromTeams && false}
      />
    </CenteredWrapper>
  );
}



export default TeamsContextProvider;
